<a
  *ngIf="customCTAHref && customCTALabel"
  class="custom-cta"
  [class]="customClass"
  [href]="customCTAHref"
  target="_blank"
  [attr.aria-label]="customCTAAriaLabel"
  >{{ customCTALabel }}</a
>
